import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  HelperViewStatus,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpen: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveConfirmationModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {





function emitClose() {
  emit('close');
}

function emitConfirm() {
  emit('confirm');
}

return { __sfc: true,emit, emitClose, emitConfirm, Modal, HelperViewStatus, ButtonPrimary, ButtonSecondary }
}

})